export default {
    nl: {
        intro: {
            subtitle: 'API',
            title: 'Systemen laten praten.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/api/hero.jpg',
        },
        type: 'API',
        title: "API's: Veilige data-uitwisseling en systeemintegratie",
        description:
            'Benut API voor efficiënte software communicatie. Met focus op veiligheid, monitoren we koppelingen en waarborgen we betrouwbaarheid.',
        content: [
            {
                type: 'text',
                title: 'API',
                content:
                    'Een API, of Application Programming Interface, is een set van regels en protocollen die het mogelijk maakt voor verschillende softwaretoepassingen om met elkaar te communiceren. Het helpt ontwikkelaars functionaliteiten en gegevens van de ene softwarecomponent naar de andere te kunnen overdragen, zonder dat ze de interne werking ervan volledig hoeven te begrijpen.',
            },
            {
                type: 'images',
                images: [
                    'https://23g-website.s3.eu-central-1.amazonaws.com/services/developers.webp',
                ],
            },
            {
                type: 'text',
                title: 'Veiligheid voorop',
                content:
                    'Bij het ontwikkelen van API-koppelingen staat veiligheid altijd centraal. Elke bit en byte die we uitwisselen wordt versleuteld. Hierbij nemen we strikte maatregelen om ervoor te zorgen dat elke informatiecel beschermd is tegen ongewenste meekijkers. Voor ons betekent beveiliging niet alleen het beschermen van gegevens, maar ook het beschermen van onze klanten. Daarom bieden we ook pentest diensten aan om de integriteit van onze digitale oplossingen te waarborgen.',
            },
            {
                type: 'quote',
                content:
                    'Voor ons betekent beveiliging niet alleen het beschermen van gegevens, maar ook van onze klanten.',
            },
            {
                type: 'text',
                title: 'Monitoren van API-koppelingen',
                content: `
                    Voortdurende waakzaamheid is wat 23G onderscheidt. Ons toegewijde team is constant op zoek naar mogelijke kwetsbaarheden in de API-koppelingen, zodat we er snel bij zijn als er iets mis lijkt te gaan. Met regelmatige controles en uitgebreide tests zien we niets over het hoofd. Hierdoor handhaven we de hoogste standaarden van beveiliging en bieden we onze gebruikers een betrouwbare en veilige API-ervaring.
                    <br><br>
                    Naast handmatige controles vertrouwen we sterk op automated testing. Deze geautomatiseerde tests worden uitgevoerd elke keer dat er wijzigingen worden aangebracht. Dit garandeert dat onze API's altijd naar behoren functioneren en voldoen aan de laatste veiligheidsnormen.
                `,
            },
            {
                type: 'case',
                case: 'nines',
            },
        ],
        related_services: ['front-end-development', 'client-portal', 'design-system'],
        contact: {
            title: '',
            employee: 'jack',
        },
    },
    en: {},
};
